module.exports = __webpack_public_path__ + "assets/4e15507fda8dea01b5952a12284804ed.png";